/**
 * 사용 내역의 기능(`operation`) 이름을 화면 말로 옮긴다 — `한글 (영어)`.
 *
 * `operation`은 nd-ai-platform이 모델을 부른 어댑터 파일 이름(`claude-<이름>.ts`·`openai-<이름>.ts`)에서 잘라
 * 기록한다. 그래서 값은 코드 이름이라 운영자가 읽을 수 없다. 어댑터를 찾지 못하면 Claude는 `query`,
 * OpenAI는 `response`로 남는다. 표에 없는 새 이름은 그대로 보인다.
 */
const LABELS: Readonly<Record<string, string>> = {
  'request-classifier': '요청 분류',
  'knowledge-answerer': '지식베이스 답변',
  'freeform-answerer': '자유 답변',
  'dev-request-namer': '개발요청 제목·slug 짓기',
  'dev-request-writer': '개발요청서 작성',
  'dev-request-merger': '개발요청서 수정',
  'document-reviser': '문서 개정',
  'symptom-reader': '제보 캡처 판독',
  'thread-summarizer': '스레드 요약',
  'sentry-investigator': '모니터링 이슈 조사',
  'assistant-agent': '봇 요청 처리',
  'approval-reply-classifier': '데이터 추출 승인 판정',
  query: '호출 위치 미상',
  response: '호출 위치 미상',
};

export class AiUsageOperation {
  static label(operation: string): string {
    const label = LABELS[operation];
    return label ? `${label} (${operation})` : operation;
  }

}
